import React, { useContext } from 'react'

import { useSelector } from 'react-redux'
import { FlexItem } from 'styled-flex-component'

import Avatar from '@components/UI/Avatar'
import { IApplicationState } from '@store'
import { selectIsSocialCampaign } from '@store/campaigns'
import { selectInfluencerHeadshot, selectInfluencerInitials } from '@store/submissions'
import Theme from '@theme'
import { H5 } from '@tribegroup'
import { SubmissionCardHeaderContext } from '../Header'
import { PlaceholderAvatar } from '../Header.styled'
import SubmissionCardHeaderAvatarSocialProfileAvatar from './SocialProfileAvatar'

const DefaultAvatar: React.FC<{ submissionId: number }> = ({ submissionId }) => {
  const { initials, headShot } = useSelector((state: IApplicationState) => ({
    initials: selectInfluencerInitials(state, submissionId),
    headShot: selectInfluencerHeadshot(state, submissionId),
  }))

  const { setIsShowAddToBrandFan } = useContext(SubmissionCardHeaderContext)

  const showBrandFansOnAvatar = () => {
    setIsShowAddToBrandFan(true)
  }

  if (headShot) {
    return (
      <Avatar size={2.5} avatarSrc={headShot.thumbnail_url} onMouseEnter={showBrandFansOnAvatar} />
    )
  }

  return (
    <PlaceholderAvatar alignCenter justifyCenter onMouseEnter={showBrandFansOnAvatar}>
      <FlexItem>
        <H5 color={Theme.grey900Color}>{initials}</H5>
      </FlexItem>
    </PlaceholderAvatar>
  )
}

interface ISubmissionCardHeaderAvatarProps {
  campaignId: number
  submissionId: number
  onClick?: (event: React.SyntheticEvent<HTMLAnchorElement>) => void
}

export const SubmissionCardHeaderAvatar: React.FC<ISubmissionCardHeaderAvatarProps> = ({
  campaignId,
  onClick,
  submissionId,
}) => {
  const showSocialProfile = useSelector((state: IApplicationState) =>
    selectIsSocialCampaign(state, campaignId),
  )

  return (
    <SubmissionCardHeaderAvatarSocialProfileAvatar
      onClick={onClick}
      submissionId={submissionId}
      avatar={!showSocialProfile ? <DefaultAvatar submissionId={submissionId} /> : undefined}
    />
  )
}

export default SubmissionCardHeaderAvatar
